module.exports = __webpack_public_path__ + "static/media/texture (36).9b4e449a.jpg";